import React, { useState, useRef, useEffect } from "react";
import DataTable from "react-data-table-component";
import { endPoints } from "../../../constant/Environment";
import {
  addData,
  deleteData,
  getAllData,
  getAllFilterData,
} from "../../../Utility/API";
import { Modal, Form, Button } from "react-bootstrap";
import UserSearch from "../../../components/FilterComponent/UserSearch";
import UserSmartSearch from "../../../components/FilterComponent/UserSmartSearch";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Actions } from "../../../redux/Actions/Actions";
import Toaster from "../../../components/Toast";
import Loader from "../../../components/Loader";
import { ErrorToast, SuccesToast } from "../../../components/Toast/message";
import { AiTwotoneEyeInvisible, AiFillEyeInvisible } from "react-icons/ai";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import moment from "moment-timezone";
import IconButton from "@mui/material/IconButton";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";
import UserProfile from "./UserProfile";

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
    </Box>
  );
}

const UserList = () => {
  const [pending, setPending] = useState(true);
  const [show, setShow] = useState(false);
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleClose = () => setShow(false);
  const [resetPaginationToggle, setResetPaginationToggle] =
    React.useState(false);
  const [limit, setLimit] = useState("");
  const maxlimit = 8000;
  const [selectedId, setSelectedId] = useState("");
  const [password, setPassword] = useState("");
  const [passwordShow, setPasswordShow] = useState(false);
  const [message, setMessage] = useState("");
  const [validated, setValidated] = useState(false);
  const [page, setPage] = React.useState(1);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [totalcount, setTotalCount] = useState(1);

  const [profileModal, setProfileModal] = useState(false);
  const [profileData, setProfileData] = useState({});

  const filteredItems = {
    // name: "",
    // platform: "1",
    // status: "",
    // regdate: "",
    // state: "",
    // city: "",
    // accounNumber: "",
    acc_status: "",
    customerId: "",
    email: "",
    kyc_status: "",
    name: "",
    player_type: "",
    rg_limit: "",
    state: "",
    userName: "",
  };
  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage + 1);
    fetchUserData(newPage + 1, filteredItems);
  };

  const handleChangeRowsPerPage = (event) => {
    // setRowsPerPage(parseInt(event.target.value, 10));
    // setPage(0);
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    // setPage(0)
  };

  useEffect(() => {
    fetchUserData(page, filteredItems);
  }, [rowsPerPage]);

  const handleSubmit = async (event) => {
    if (limit > maxlimit) {
      ErrorToast("Exceeds Maximum Allowed Limit");
    } else {
      let data = {
        id_user: selectedId,
        value: limit,
        d_user_limit: maxlimit,
      };
      let url = endPoints.api.SetUserLimit;
      addData(url, data)
        .then((response) => {
          if (response.data.status === "success") {
            SuccesToast(response.data.message);

            handleClose();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };
  const handleShow = (userId) => {
    setShow(true);
    setSelectedId(userId);
    FetchUserLimit(userId);
  };
  const FetchUserLimit = (userId) => {
    let url = `${endPoints.api.GetUserLimit}${userId}`;
    getAllData(url)
      .then((response) => {
        if (response?.status == "success") {
          setLimit(response.data.value);
        } else {
          setLimit("");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  function getNumberOfPages(rowCount, rowsPerPage) {
    return Math.ceil(rowCount / rowsPerPage);
  }

  function toPages(pages) {
    const results = [];
    for (let i = 1; i <= pages; i++) {
      results.push(i);
    }

    return results;
  }

  const DeleteUser = (userId) => {
    setIsLoading(true);
    let url = `${endPoints.api.DELETE_USER}/${userId}`;
    deleteData(url)
      .then((response) => {
        setIsLoading(false);

        console.log("res", response);
        if (response.data.status === "success") {
          SuccesToast("User Deleted Successfully.");
          fetchUserData();
        } else {
          ErrorToast(response.data.message);
        }
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  };
  useEffect(() => {
    fetchUserData(1, filteredItems);
    // fetchUserData1(filteredItems);
  }, []);

  // withdrawl payments get api call
  const fetchUserData = async (page, data) => {
    let url = `${endPoints.api.GET_USERS}/${page}/${rowsPerPage}`;
    setIsLoading(true);
    await getAllFilterData(url, data)
      .then((response) => {
        setIsLoading(false);
        if (response.status === "success") {
          let data = response.data;
          setRows(response.data);
          // console.log("data row",response.data.type);
          setPending(false);
          const ITEMS_PER_PAGE = rowsPerPage;
          setTotalCount(data[0]?.totalcount);
          const totalCount = data[0]?.totalcount;
          const totalPagesCount = Math.ceil(totalCount / ITEMS_PER_PAGE);
          // setTotalPages(totalPagesCount);
          //
        } else {
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
      });
  };

  // old method without pagination
  const fetchUserData1 = async (data) => {
    let url = `${endPoints.api.GET_USERS}`;
    setIsLoading(true);
    await getAllFilterData(url, data)
      .then((response) => {
        setIsLoading(false);
        if (response.status === "success") {
          const result = response?.data?.filter(
            (item) => item.type == 6 || item.type == 2 || item.type == 1
          );
          setRows(result);
          setPending(false);
        } else {
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
      });
  };
  const create = () => {
    navigate("/CreateUser");
  };
  const searchList = (filterObj) => {
    fetchUserData(1, filterObj);
  };

  return (
    <>
      <div className="main">
        <Toaster></Toaster>
        {isLoading && <Loader spinner={true} visible={isLoading} />}
        <div id="Sportbook" style={{ padding: "0px" }}>
          <div className="container-fluid bg-color-sportbook custom-card4">
            <div className="inner-space1">
              <div className="row">
                <div className="col-md-12">
                  <h2 className="mb-2">Users</h2>
                </div>
              </div>

              <div className="row" style={{ padding: "5px 0px 20px 0px" }}>
                <div className="col-md-12">
                  <UserSmartSearch
                    addNew={create}
                    searchList={searchList}
                  ></UserSmartSearch>
                </div>
              </div>

              <div className="row">
                <div className="col-md-12">
                  <TableContainer component={Paper}>
                    <Table
                      className="c_table"
                      size="small"
                      stickyHeader
                      aria-label="sticky a dense custom pagination"
                      sx={{ minWidth: 500 }}
                      // aria-label="custom pagination table"
                    >
                      <TableHead>
                        <TableRow>
                          <TableCell align="center">Customer ID</TableCell>
                          <TableCell align="center">User Name</TableCell>
                          <TableCell align="center">First Name</TableCell>
                          <TableCell align="center">Last Name</TableCell>
                          <TableCell align="center">Email</TableCell>
                          <TableCell align="center">State</TableCell>
                          <TableCell align="center">Signup Date</TableCell>
                          <TableCell align="center">Account Staus</TableCell>
                          <TableCell align="center">KYC Status</TableCell>
                          <TableCell align="center">Player Type</TableCell>
                          <TableCell align="center">Play</TableCell>
                          <TableCell align="center">RG Limits</TableCell>
                          <TableCell align="center">Actions</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {rows.map((row) => (
                          <TableRow
                            key={row.idUser}
                            sx={{
                              "&:last-child td, &:last-child th": {
                                border: 0,
                              },
                            }}
                          >
                            <TableCell align="center">{row.idUser}</TableCell>
                            <TableCell align="center">{row.login}</TableCell>
                            <TableCell align="center">{row.name}</TableCell>
                            <TableCell align="center">{row.surname}</TableCell>
                            <TableCell align="center">{row.email}</TableCell>
                            <TableCell align="center">
                              {row.stateName}
                            </TableCell>
                            <TableCell>
                              {moment(row.insertionTime).format("MM/DD/YYYY")}
                            </TableCell>
                            <TableCell align="center">
                              {row.accountStatus}
                            </TableCell>
                            <TableCell align="center">
                              {row.kycStatus}
                            </TableCell>
                            <TableCell align="center">
                              {row.playerType}
                            </TableCell>
                            <TableCell align="center">
                              {`${row.multplier}x`}
                            </TableCell>
                            <TableCell align="center">{row.rgType}</TableCell>
                            <TableCell align="center">
                              <Button
                                variant="primary"
                                className="mrglft10"
                                onClick={() => {
                                  setProfileData(row);
                                  setProfileModal(true);
                                }}
                              >
                                Update Profile
                              </Button>
                              <Button
                                variant="primary"
                                className="mrglft10"
                                onClick={() => {
                                  navigate({
                                    pathname: `/UserDetails/${row.idUser}`,
                                  });
                                }}
                              >
                                View
                              </Button>
                            </TableCell>
                          </TableRow>
                        ))}

                        {/* {emptyRows > 0 && (
                          <TableRow style={{ height: 53 * emptyRows }}>
                            <TableCell colSpan={6} />
                          </TableRow>
                        )} */}
                      </TableBody>
                      <TableFooter>
                        <TableRow>
                          <TablePagination
                            className="hide-rows-per-page-options"
                            rowsPerPageOptions={[5, 10, 25, 50, 100, 200]}
                            colSpan={12}
                            count={
                              rowsPerPage === -1 ? rows.length : totalcount
                            }
                            rowsPerPage={rowsPerPage}
                            page={page - 1}
                            // count={rowsToDisplay.length}
                            // rowsPerPage={rowsPerPage}
                            // page={page}
                            SelectProps={{
                              inputProps: {
                                "aria-label": "rows per page",
                              },
                              native: true,
                            }}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            ActionsComponent={TablePaginationActions}
                          />
                        </TableRow>
                      </TableFooter>
                    </Table>
                  </TableContainer>
                </div>
                <>
                  <Modal
                    show={show}
                    onHide={handleClose}
                    style={{ marginTop: "10%" }}
                  >
                    <Modal.Body
                      style={{
                        padding: "0px !important",
                        background: "#24262b",
                      }}
                    >
                      <Form
                        noValidate
                        validated={validated}
                        style={{
                          maxWidth: "500px",
                          width: "100%",
                          margin: "0 auto",

                          borderRadius: "5px",
                          padding: "0px 45px 20px",
                          backgroundColor: "#24262b",
                        }}
                      >
                        <h2
                          className="mb-4"
                          style={{
                            color: "white",
                            justifyContent: "center",
                            display: "flex",
                            fontWeight: "bold",
                            padding: "5px",
                          }}
                        >
                          Update Account Limit
                        </h2>

                        <Form.Group className="mb-3" controlId="EMAIL">
                          <Form.Label
                            className="my-form-label"
                            style={{ color: "white" }}
                          >
                            Required Account Limit
                          </Form.Label>

                          <Form.Control
                            required
                            placeholder="Account Limit"
                            value={limit}
                            onChange={(e) => setLimit(e.target.value)}
                          />
                          <Form.Control.Feedback type="invalid">
                            Please enter account limit
                          </Form.Control.Feedback>
                        </Form.Group>
                        <div className="login-btn-last  mt-5">
                          <Button
                            className="login-btn-form"
                            variant="primary"
                            onClick={handleSubmit}
                          >
                            SUBMIT
                          </Button>
                        </div>
                      </Form>
                    </Modal.Body>
                  </Modal>
                </>

                <UserProfile
                  open={profileModal}
                  onClose={(flag) => {
                    if(flag){
                      setProfileModal(false);
                      fetchUserData(page, filteredItems);
                    }else{
                      setProfileModal(false);
                    }
                    
                  }}
                  profileData={profileData}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserList;
